module.exports = __webpack_public_path__ + "img/folder.914cb071.svg";